export function convertArrowToColumnarTable(table) {
  const arrowTable = table.data;
  const columnarTable = {};
  for (const field of arrowTable.schema.fields) {
    const arrowColumn = arrowTable.getChild(field.name);
    const values = arrowColumn === null || arrowColumn === void 0 ? void 0 : arrowColumn.toArray();
    columnarTable[field.name] = values;
  }
  return {
    shape: 'columnar-table',
    schema: table.schema,
    data: columnarTable
  };
}
//# sourceMappingURL=convert-arrow-to-columnar-table.js.map